module.exports = __webpack_public_path__ + "img/delivery_manifest.39c0c5be.svg";